export declare namespace InspectionValidationSummaryTokenSections {
	interface Title {
		color: string;
		fontSize: string;
		fontWeight: string;
		lineHeight: string;
	}

	interface List {
		color: string;
		fontSize: string;
		lineHeight: string;
		gap: string;
	}
}

export type InspectionValidationSummaryTokens = {
	background: string;
	borderColor: string;
	borderRadius: string;
	padding: string;
	gap: string;
	title: InspectionValidationSummaryTokenSections.Title;
	list: InspectionValidationSummaryTokenSections.List;
};

export const title: InspectionValidationSummaryTokenSections.Title = {
	color: '{text.color}',
	fontSize: '1rem',
	fontWeight: '600',
	lineHeight: '1.5rem',
};

export const list: InspectionValidationSummaryTokenSections.List = {
	color: '{text.color}',
	fontSize: '0.875rem',
	lineHeight: '1.5rem',
	gap: '0.25rem',
};

/**
 * Validation summary block for FluentValidation errors on inspection steps.
 * Uses semantic tokens for error/warn appearance.
 */
export default {
	background: '{surface.50}',
	borderColor: '{form.field.invalid.border.color}',
	borderRadius: '{content.border.radius}',
	padding: '1rem 1.25rem',
	gap: '0.5rem',
	title,
	list,
} satisfies InspectionValidationSummaryTokens;
